import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

export const useNotificationSSE = (accessToken, onNewNotification) => {
    const eventSourceRef = useRef(null);
    const userDetails = useSelector((state) => state.auth?.userDetails);
    const SSE_URL = `http://127.0.0.1:8020/gateway/notification-events/${userDetails?.user_id}/`;

    useEffect(() => {
        if (!accessToken) return;

        // Create SSE connection
        const eventSource = new EventSource(`${SSE_URL}`);

        eventSource.onmessage = (event) => {
            try {
                const data = JSON.parse(event.data);

                // Check if this is a notification change event
                if (data.changes_for === 'notification') {
                    onNewNotification(data);
                }
            } catch (error) {
                console.error('Error parsing SSE data:', error);
            }
        };

        eventSource.onerror = (error) => {
            console.error('SSE connection error:', error);
            eventSource.close();
        };

        eventSourceRef.current = eventSource;

        // Cleanup on unmount
        return () => {
            eventSource.close();
        };
    }, [accessToken, onNewNotification, SSE_URL]);
};